/* Grid-item JS hoisted out of snippets/product-grid-item-variant.liquid, 11 Aug 2026.
   Both blocks already self-guarded (__dorabiQuickAddInit / __dorabiQAportal) so they
   only ever ran once - but the bytes shipped once per card. Both use document-level
   delegation and customElements.define, so loading deferred from <head> is safe. */

/* ---- quick-add (was inline in product-grid-item-variant.liquid) ---- */
(function () {
  if (!window.__dorabiQuickAddInit) {
    window.__dorabiQuickAddInit = true;
  } else {
    return;
  }

  var css = [
    /* Desktop: while a card is hovered, the whole quick-add overlay catches */
    /* clicks so stray clicks on its empty area can't fall through to the card link. */
    '.product-grid-item:hover .product-grid-item__content:not(.is-mobile) .product-grid-item__actions { pointer-events: auto; }',
    /* Touch: once a card is "armed", force the overlay visible & interactive */
    /* (there is no :hover on touch devices). */
    '.product-grid-item.quick-add-armed .product-grid-item__actions { opacity: 1 !important; transform: none !important; pointer-events: auto !important; }',
    '.product-grid-item.quick-add-armed inline-add-product.is-open .inline-add-product__options-menu { transform: translateY(0%); opacity: 1; transition: opacity var(--enter-animation-duration) cubic-bezier(0.215,0.61,0.355,1), transform var(--enter-animation-duration) cubic-bezier(0.215,0.61,0.355,1); }',
    'inline-add-product.is-open .inline-add-product__options-menu { transform: translateY(0%); opacity: 1; }',
    'inline-add-product.is-open .inline-add-product__options-menu-list { opacity: 1; transform: translateY(0%); }',
    'inline-add-product.is-open .inline-add-product__button-facade-label { opacity: 0; transform: translateY(100%); }'
  ].join('\n');
  var style = document.createElement('style');
  style.setAttribute('data-inline-add-product', '');
  style.textContent = css;
  document.head.appendChild(style);

  var noHover = window.matchMedia('(hover: none), (pointer: coarse)');

  function disarmAll(except) {
    document.querySelectorAll('.product-grid-item.quick-add-armed').forEach(function (el) {
      if (el !== except) el.classList.remove('quick-add-armed');
    });
    document.querySelectorAll('inline-add-product.is-open').forEach(function (el) {
      if (!except || !except.contains(el)) el.classList.remove('is-open');
    });
  }

  // Returns the quick-add overlay for the currently visible variant of an item.
  function visibleActions(item) {
    var v = item.querySelector('product-grid-item-variant:not([hidden]) .product-grid-item__actions');
    return v || item.querySelector('.product-grid-item__actions');
  }

  // Capture phase so we run before the card link navigates.
  document.addEventListener('click', function (e) {
    var item = e.target.closest('product-grid-item');

    // Tapped outside any product card -> close everything.
    if (!item) { disarmAll(); return; }

    // Let real add-to-cart / quick-view buttons work normally.
    if (e.target.closest('[data-add-to-cart], button, product-add-button')) return;

    // Once armed, the overlay itself captures pointer events, so there is no
    // longer any risk of falling through to the card link. Let it behave normally.
    if (item.classList.contains('quick-add-armed')) return;

    // Only intervene on touch / hover-less devices.
    if (!noHover.matches) return;

    var actions = visibleActions(item);
    if (!actions) return;

    // On true mobile widths the theme hides the overlay (display:none) and the
    // card is meant to navigate to the product page -> leave that alone.
    if (getComputedStyle(actions).display === 'none') return;

    // Only intercept taps over the ADD button band at the bottom of the card.
    // Taps on the product image (above the button) and on the title / price
    // links still navigate to the product page as normal.
    var btn = actions.querySelector('.inline-add-product__button-facade-wrapper, .product-grid-item__btn, button') || actions;
    var r = btn.getBoundingClientRect();
    var pad = 12; // forgiving margin so the button's edges/"sides" are covered
    if (e.clientX < r.left - pad || e.clientX > r.right + pad || e.clientY < r.top - pad || e.clientY > r.bottom + pad) return;

    // First tap over the overlay: reveal the quick-add, block navigation.
    e.preventDefault();
    e.stopPropagation();
    disarmAll(item);
    item.classList.add('quick-add-armed');
    var iap = actions.matches('inline-add-product') ? actions : actions.querySelector('inline-add-product');
    if (iap) iap.classList.add('is-open');
  }, true);

  // Desktop click-to-toggle for the inline size menu (and keeps it open on touch).
  if (window.customElements && !customElements.get('inline-add-product')) {
    customElements.define('inline-add-product', class extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.addEventListener('click', this._onClick.bind(this));
      }
      _onClick(e) {
        if (e.target.closest('[data-add-to-cart], button, product-add-button')) return;
        e.preventDefault();
        var opening = !this.classList.contains('is-open');
        document.querySelectorAll('inline-add-product.is-open').forEach(function (el) {
          if (el !== this) el.classList.remove('is-open');
        }, this);
        this.classList.toggle('is-open', opening);
      }
    });
  }
})();

/* ---- quick-add sheet (was inline in product-grid-item-variant.liquid) ---- */
(function(){
  if (window.__dorabiQAportal) return; window.__dorabiQAportal = true;
  // The sheet used to be moved into <body> (document.body.appendChild) to escape
  // the card's overflow:hidden. But moving a node re-runs connectedCallback on the
  // <product-add-button>s inside it, and theme.js re-binds its addToCartAction
  // there -- so the handler ended up registered twice and one tap dispatched two
  // identical /cart/add calls 3ms apart. Only the touch path portals, which is why
  // it was mobile-only.
  //
  // The move was never actually necessary: position:fixed already escapes an
  // ancestor's overflow:hidden, and nothing in the card creates a containing block
  // (no transform/filter/perspective/will-change/contain) or a stacking context.
  // So toggle the class and leave the node where it is.
  //
  // Caveat for future edits: adding a transform to a product card would make that
  // card the containing block and break the fixed positioning here.
  function portal(el){
    if (el.__portaled) return;
    var bd = el.querySelector('.inline-add-product__backdrop');
    var menu = el.querySelector('.inline-add-product__options-menu');
    if(!menu) return;
    el.__bd = bd; el.__menu = menu; el.__portaled = true;
    if(bd) bd.classList.add('iap-portaled');
    menu.classList.add('iap-portaled');
    document.documentElement.classList.add('iap-lock');
  }
  function unportal(el){
    if(!el.__portaled) return; el.__portaled=false;
    if(el.__bd) el.__bd.classList.remove('iap-portaled');
    if(el.__menu) el.__menu.classList.remove('iap-portaled');
    if(!document.querySelector('inline-add-product.is-open')) document.documentElement.classList.remove('iap-lock');
  }
  function sync(el){ el.classList.contains('is-open') ? portal(el) : unportal(el); }
  var mo=new MutationObserver(function(ms){ ms.forEach(function(m){ sync(m.target); }); });
  function observe(){ document.querySelectorAll('inline-add-product').forEach(function(el){ if(!el.__obs){ el.__obs=true; mo.observe(el,{attributes:true,attributeFilter:['class']}); } }); }
  observe(); document.addEventListener('DOMContentLoaded', observe);
  // Expose so dynamically-injected grid items (e.g. AJAX recommendations) can register their quick-add.
  window.__dorabiQAobserve = observe;
  function closeAll(){
    document.querySelectorAll('inline-add-product.is-open').forEach(function(el){ el.classList.remove('is-open'); });
    document.querySelectorAll('.product-grid-item.quick-add-armed').forEach(function(el){ el.classList.remove('quick-add-armed'); });
  }


  // close on X / backdrop
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-quickadd-close]')){ e.preventDefault(); e.stopPropagation(); closeAll(); return; }
    // after picking a size (add to cart) -> close the sheet. The drawer is
    // deliberately NOT opened: it used to fire on click rather than on a
    // successful add, so it could appear before the item had landed. The
    // theme:cart:reload below still refreshes the header cart count.
    if(e.target.closest('.iap-portaled .inline__variant__add, .iap-portaled [data-add-to-cart]')){
      var m=document.querySelector('.inline-add-product__options-menu.iap-portaled'); if(m) m.classList.add('iap-hidden');
      var b=document.querySelector('.inline-add-product__backdrop.iap-portaled'); if(b) b.classList.add('iap-hidden');
      document.documentElement.classList.remove('iap-lock');
      setTimeout(function(){ closeAll(); document.dispatchEvent(new CustomEvent('theme:cart:reload',{bubbles:true})); }, 700);
    }
  }, true);
})();

/* ---- infinite loading for collection grids (11 Aug 2026) ----
   Replaces click-through pagination with append-on-scroll. Deliberately additive:
   the server still renders real, crawlable paginated pages and the numeric widget
   stays in the DOM (visually hidden) so no-JS and SEO are unaffected.

   Costs nothing on first paint - this file is already deferred and cached, and the
   first fetch only fires when the shopper nears the end of the grid.

   Auto-loads AUTO_PAGES batches, then switches to an explicit button so the footer
   stays reachable instead of running away from the shopper. */
(function () {
  if (window.__dorabiInfinite) return;
  window.__dorabiInfinite = true;

  var AUTO_PAGES = 3;
  var autoLeft = AUTO_PAGES;
  var busy = false;

  function nextUrlFrom(scope) {
    var arrs = scope.querySelectorAll('.pagination-custom__arr');
    var last = arrs[arrs.length - 1];
    var a = last && last.querySelector('a[href]');
    return a ? a.getAttribute('href') : null;
  }

  function init() {
    var grid = document.querySelector('.js-grid');
    var wrap = document.querySelector('[data-collection-pagination]');
    if (!grid || !wrap || !nextUrlFrom(wrap)) return;

    wrap.classList.add('dg-pag--js');

    var ui = document.createElement('div');
    ui.className = 'dg-more';
    ui.innerHTML =
      '<div class="dg-more__sentinel" aria-hidden="true"></div>' +
      '<button type="button" class="dg-more__btn" hidden>Load more</button>' +
      '<span class="dg-more__spinner" aria-hidden="true"></span>' +
      '<span class="dg-more__status" role="status" aria-live="polite"></span>';
    wrap.parentNode.insertBefore(ui, wrap);

    var sentinel = ui.querySelector('.dg-more__sentinel');
    var btn = ui.querySelector('.dg-more__btn');
    var status = ui.querySelector('.dg-more__status');

    function showButton() {
      btn.hidden = false;
      if (io) io.unobserve(sentinel);
    }

    /* Fetch only this section rather than the whole document - same markup, about a
       third less to download and parse (796 KB vs 1.20 MB measured on august-sale). */
    var sectionId = (document.querySelector('[data-section-type="collection"]') || {}).getAttribute
      ? document.querySelector('[data-section-type="collection"]').getAttribute('data-section-id')
      : null;
    function sectionUrl(url) {
      if (!sectionId) return url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
    }

    function load() {
      var url = nextUrlFrom(wrap);
      if (busy || !url) return;
      busy = true;
      btn.disabled = true;
      ui.classList.add('is-loading');
      status.textContent = 'Loading more products';

      fetch(sectionUrl(url), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('.js-grid');
          var newPag = doc.querySelector('[data-collection-pagination]');
          if (!incoming) throw new Error('no grid in response');

          var frag = document.createDocumentFragment();
          while (incoming.firstElementChild) frag.appendChild(incoming.firstElementChild);
          var added = frag.childElementCount;
          grid.appendChild(frag);

          /* swap in the fetched pagination so the next href is current; if the
             response has none we are on the last page. */
          if (newPag) {
            wrap.innerHTML = newPag.innerHTML;
            wrap.setAttribute('data-shown', newPag.getAttribute('data-shown') || '');
          } else {
            wrap.innerHTML = '';
          }

          var done = !nextUrlFrom(wrap);
          status.textContent = added + ' more products loaded' + (done ? ', end of list' : '');
          if (done) {
            ui.classList.add('dg-more--done');
            btn.remove();
            if (io) io.disconnect();
          } else if (autoLeft-- <= 0) {
            showButton();
          }
          document.dispatchEvent(new CustomEvent('theme:grid:appended', { bubbles: true, detail: { added: added } }));
        })
        .catch(function () {
          status.textContent = '';
          showButton();          /* fall back to a manual retry rather than dying quietly */
        })
        .then(function () {
          busy = false;
          btn.disabled = false;
          ui.classList.remove('is-loading');
        });
    }

    btn.addEventListener('click', load);

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) load();
      }, { rootMargin: '800px 0px' });
      io.observe(sentinel);
    } else {
      showButton();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
